<template>
  <AdminNavbar>
    <h1 class="font-bold text-lg">Судалгаа, тайлан</h1>
    <div class="bg-white rounded shadow">
      <div
        class="flex justify-between items-center border-t-4 border-t-blue-500 rounded-t border-b p-3"
      >
        <h6 class="text-base">Тайлан</h6>
        <router-link
          to="/admin/report"
          class="bg-blue-500 p-2 text-white text-xs rounded hover:bg-blue-600"
        >
          <font-awesome-icon icon="fa-solid fa-list" class="mr-1" />
          Тайлангийн жагсаалт
        </router-link>
      </div>

      <MMEditReport />
    </div>
  </AdminNavbar>
</template>

<script>
import AdminNavbar from "@/components/admin/AdminNavbar.vue";
import MMEditReport from "@/containers/MiningMongolia/admin/MMEditReport.vue";

export default {
  name: "MMAddReport",
  components: {
    AdminNavbar,
    MMEditReport,
  },
  setup() {
    return {};
  },
};
</script>
